import { render } from "./UploadPlanilhaLayout.vue?vue&type=template&id=b74a2664&scoped=true"
import script from "./UploadPlanilhaLayout.vue?vue&type=script&lang=js"
export * from "./UploadPlanilhaLayout.vue?vue&type=script&lang=js"

import "./UploadPlanilhaLayout.vue?vue&type=style&index=0&id=b74a2664&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74a2664"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QChip});
